import React from "react";
import { Heading } from "../Heading";
export const CardsWithTitleAndSub = ({ title, content, linkLabel, linkUrl }) => (React.createElement("div", { className: "cards-with-title-and-sub-root" },
    React.createElement(Heading, { design: "h5-bold" }, title),
    React.createElement("div", { className: "cards-with-title-and-sub-root__card-contentWrapper" },
        React.createElement("p", null, content),
        React.createElement("a", { href: linkUrl }, linkLabel))));
